module.exports = (app) => app.directive('aclPermission', /* @ngInject */ function (aclService) {

	return {
		restrict: 'AE',
		priority: 10000,
		// transclude: true,
		scope: {
			aclResource: '@',
			aclAction: '@'
		},
		link: function (scope, element, attributes) {
			// return function ($scope) {
				// hide element during the checking process
				element.addClass('d-none');

				aclService.getPermission(scope.aclResource, scope.aclAction).then((response) => {
					if (!response.allow) {
						// remove element (and it's children) from dom
						element.children().remove();
						element.remove();
					} else {
						element.removeClass('d-none');
					}

				}, (e) => {
					console.error(e);
				});
			// };
		}
	}

});
